import { FC } from 'react'
import { Row, Col, Divider, Button, Dropdown, Checkbox, Text } from '@mch-group/uikit-components'
import { scrollToElement } from '@utils/scroll'
import * as Yup from 'yup'
import { withFormik } from 'formik'
import validationConstants from '@constants/validation'
import { PressAcc as PressAccService } from '@services'

interface IProfileForm {
  handleSubmit: any
  values: any
  touched: any
  setFieldValue: any
  setFieldTouched: any
  errors: any
  setProfileOpen: any
  isSubmitting: boolean
  countries: any
  mediaFunctions: any
  mediaTypes: any
  salutations: any
  props: any
  isProfileOpen: any
}

interface IProfileFormikComponent extends IProfileForm {
  handleSubmit: any
  values: any
  touched: any
  setFieldValue: any
  setFieldTouched: any
  errors: any
  setProfileOpen: any
  isSubmitting: boolean
  countries: any
  mediaFunctions: any
  mediaTypes: any
  salutations: any
  props: any
}

const ProfileFormikComponent: FC<IProfileFormikComponent> = ({
  handleSubmit,
  values,
  touched,
  setFieldValue,
  setFieldTouched,
  errors,
  setProfileOpen,
  isSubmitting,
  countries,
  mediaFunctions,
  mediaTypes,
  salutations,
  props
}) => (
  <form onSubmit={handleSubmit}>
    <Row className={'press-accreditation-profile__edit'} gutter='g-5 g-md-6 g-xl-7 pb-5 pb-md-3 pb-lg-5 pb-xl-4'>
      <Col xs={12} sm={12} md={3} lg={4} xl={3}>
        <Row gutter='g-5 g-md-6 g-xl-7'>
          <Col
            xs={{ span: 6, offset: 3 }}
            sm={{ span: 6, offset: 3 }}
            md={{ span: 12, offset: 0 }}
            lg={{ span: 9, offset: 3 }}
            xl={{ span: 8, offset: 4 }}
          ></Col>
        </Row>
      </Col>
      <Col xs={12} sm={12} md={9} lg={8} xl={6}>
        {/* Personal Block */}
        <Row gutter='g-5 g-md-6 g-xl-7'>
          <Col xs={12} md={9} className='mb-0'>
            <h3 className='h5'>{props.mpapd_personal_lbl || 'Personal'}</h3>
          </Col>
          {/* Salutation */}
          <Col xs={12} md={6} className='mt-5 mt-md-5 mt-lg-5 mt-xl-5 mb-3 mb-md-4 mb-lg-4 mb-xl-4'>
            <Dropdown
              label={props.mpapd_salutation}
              variant='single'
              options={salutations.map((item) => ({ label: item.value || '', value: item.code || '' }))}
              value={values.mailingSalutationId || ''}
              // @ts-ignore
              onChange={(e) => setFieldValue('mailingSalutationId', e)}
              // @ts-ignore
              onBlur={(e) => {
                setFieldTouched(e)
              }}
              helpText={touched.mailingSalutationId && errors.mailingSalutationId}
              helpTextType={touched.mailingSalutationId && errors.mailingSalutationId ? 'danger' : 'muted'}
              placeholder={props.mpapd_select}
              onVisibilityChange={() => {}}
            />
          </Col>
          <Col xs={12} md={6} className='mt-5 mt-md-5 mt-lg-5 mt-xl-5 mb-3 mb-md-4 mb-lg-4 mb-xl-4 d-none d-md-block' />
          {/* Name */}
          <Col xs={12} md={6} className='mt-5 mt-md-5 mt-lg-5 mt-xl-5 mb-3 mb-md-4 mb-lg-4 mb-xl-4'>
            <Text
              label={props.mpapd_name}
              type='text'
              value={values.firstName || ''}
              onChange={(e) => setFieldValue('firstName', e.target.value)}
              onBlur={() => setFieldTouched('firstName')}
              id='firstName'
              helpText={touched.firstName && errors.firstName}
              helpTextType={errors.firstName && touched.firstName ? 'danger' : 'muted'}
              //@ts-ignore
              maxLength='50'
            />
          </Col>
          {/* Surname */}
          <Col xs={12} md={6} className='mt-5 mt-md-5 mt-lg-5 mt-xl-5 mb-3 mb-md-4 mb-lg-4 mb-xl-4'>
            <Text
              label={props.mpapd_surname}
              type='text'
              value={values.lastName || ''}
              onChange={(e) => setFieldValue('lastName', e.target.value)}
              onBlur={() => setFieldTouched('lastName')}
              id='lastName'
              helpText={touched.lastName && errors.lastName}
              helpTextType={errors.lastName && touched.lastName ? 'danger' : 'muted'}
              //@ts-ignore
              maxLength='50'
            />
          </Col>
          {/* Organization */}
          <Col xs={12} md={6} className='mt-5 mt-md-5 mt-lg-5 mt-xl-5 mb-3 mb-md-4 mb-lg-4 mb-xl-4'>
            <Text
              label={props.mpapd_organization}
              type='text'
              value={values.companyName || ''}
              onChange={(e) => setFieldValue('companyName', e.target.value)}
              onBlur={() => setFieldTouched('companyName')}
              id='companyName'
              helpText={touched.companyName && errors.companyName}
              helpTextType={errors.companyName && touched.companyName ? 'danger' : 'muted'}
              //@ts-ignore
              maxLength='50'
            />
          </Col>
          {/* Media Type */}
          <Col xs={12} md={6} className='mt-5 mt-md-5 mt-lg-5 mt-xl-5 mb-3 mb-md-4 mb-lg-4 mb-xl-4'>
            <Dropdown
              label={props.mpapd_media_type}
              variant='single'
              options={mediaTypes?.map((item) => ({
                label: item.value || '',
                value: item.code || ''
              }))}
              value={values.mediaType || ''}
              // @ts-ignore
              onChange={(e) => setFieldValue('mediaType', e)}
              // @ts-ignore
              onBlur={(e) => {
                setFieldTouched(e)
              }}
              helpText={touched.mediaType && errors.mediaType}
              helpTextType={touched.mediaType && errors.mediaType ? 'danger' : 'muted'}
              placeholder={props.mpapd_select}
              onVisibilityChange={() => {}}
            />
          </Col>
          {/* Function */}
          <Col xs={12} md={6} className='mt-5 mt-md-5 mt-lg-5 mt-xl-5 mb-3 mb-md-4 mb-lg-4 mb-xl-4'>
            <Dropdown
              label={props.mpapd_function}
              variant='single'
              options={mediaFunctions?.map((item) => ({
                label: item.value || '',
                value: item.code || ''
              }))}
              value={values.mediaFunction || ''}
              // @ts-ignore
              onChange={(e) => setFieldValue('mediaFunction', e)}
              // @ts-ignore
              onBlur={(e) => {
                setFieldTouched(e)
              }}
              helpText={touched.mediaFunction && errors.mediaFunction}
              helpTextType={touched.mediaFunction && errors.mediaFunction ? 'danger' : 'muted'}
              placeholder={props.mpapd_select}
              onVisibilityChange={() => {}}
            />
          </Col>
        </Row>

        {/* Divider */}
        <Row className='g-5 g-md-6 g-xl-7'>
          <Col xs={9} lg={9} xl={10}>
            <Divider
              color='mch-gray-200'
              size='m'
              className='mt-7 mt-md-8 mt-lg-8 mt-xl-8 mb-8 mb-md-8 mb-lg-9 mb-xl-9'
            />
          </Col>
        </Row>

        {/* Contact Block */}
        <Row gutter='g-5 g-md-6 g-xl-7'>
          <Col md={9} className='mb-0'>
            <h3 className='h5'>{props.mpapd_contact_information || 'Contact Information'}</h3>
          </Col>
          <Col md={12} className='mt-5 mt-md-5 mt-lg-5 mt-xl-5 mb-3 mb-md-4 mb-lg-4 mb-xl-4'>
            <Text
              label={props.mpapd_address_line_1}
              type='text'
              value={values.street1 || ''}
              onChange={(e) => {
                setFieldValue('street1', e.target.value)
              }}
              onBlur={() => {
                setFieldTouched('street1')
              }}
              id='street1'
              helpText={touched.street1 && errors.street1}
              helpTextType={errors.street1 && touched.street1 ? 'danger' : 'muted'}
              //@ts-ignore
              maxLength='250'
            />
          </Col>
          <Col md={12} className='mt-5 mt-md-5 mt-lg-5 mt-xl-5 mb-3 mb-md-4 mb-lg-4 mb-xl-4'>
            <Text
              label={props.mpapd_address_line_2}
              type='text'
              value={values.street2 || ''}
              onChange={(e) => {
                setFieldValue('street2', e.target.value)
              }}
              onBlur={() => setFieldTouched('street2')}
              id='street2'
              helpText={touched.street2 && errors.street2}
              helpTextType={errors.street2 && touched.street2 ? 'danger' : 'muted'}
              //@ts-ignore
              maxLength='250'
            />
          </Col>
          <Col md={12} className='mt-5 mt-md-5 mt-lg-5 mt-xl-5 mb-3 mb-md-4 mb-lg-4 mb-xl-4'>
            <Text
              label={props.mpapd_address_line_3}
              type='text'
              value={values.street3 || ''}
              onChange={(e) => {
                setFieldValue('street3', e.target.value)
              }}
              onBlur={() => setFieldTouched('street3')}
              id='street3'
              helpText={touched.street3 && errors.street3}
              helpTextType={errors.street3 && touched.street3 ? 'danger' : 'muted'}
              //@ts-ignore
              maxLength='250'
            />
          </Col>
          <Col md={6} className='mt-5 mt-md-5 mt-lg-5 mt-xl-5 mb-3 mb-md-4 mb-lg-4 mb-xl-4'>
            <Text
              label={props.mpapd_city}
              type='text'
              value={values.city || ''}
              onChange={(e) => {
                setFieldValue('city', e.target.value)
              }}
              onBlur={() => setFieldTouched('city')}
              id='city'
              helpText={touched.city && errors.city}
              helpTextType={errors.city && touched.city ? 'danger' : 'muted'}
              //@ts-ignore
              maxLength='80'
            />
          </Col>
          <Col md={6} className='mt-5 mt-md-5 mt-lg-5 mt-xl-5 mb-3 mb-md-4 mb-lg-4 mb-xl-4'>
            <Text
              label={props.mpapd_state}
              type='text'
              value={values.state || ''}
              onChange={(e) => {
                setFieldValue('state', e.target.value)
              }}
              onBlur={() => setFieldTouched('state')}
              id='state'
              helpText={touched.state && errors.state}
              helpTextType={errors.state && touched.state ? 'danger' : 'muted'}
              //@ts-ignore
              maxLength='80'
            />
          </Col>
          <Col md={6} className='mt-5 mt-md-5 mt-lg-5 mt-xl-5 mb-3 mb-md-4 mb-lg-4 mb-xl-4'>
            <Text
              label={props.mpapd_zip_code}
              type='text'
              value={values.zipCode || ''}
              onChange={(e) => {
                setFieldValue('zipCode', e.target.value)
              }}
              onBlur={() => setFieldTouched('zipCode')}
              id='zipCode'
              helpText={touched.zipCode && errors.zipCode}
              helpTextType={errors.zipCode && touched.zipCode ? 'danger' : 'muted'}
              //@ts-ignore
              maxLength='20'
            />
          </Col>
          <Col md={6} className='mt-5 mt-md-5 mt-lg-5 mt-xl-5 mb-3 mb-md-4 mb-lg-4 mb-xl-4'>
            <Text
              label={props.mpapd_po_box}
              type='text'
              value={values.postOfficeBox || ''}
              onChange={(e) => {
                setFieldValue('postOfficeBox', e.target.value)
              }}
              onBlur={() => setFieldTouched('postOfficeBox')}
              id='postOfficeBox'
              helpText={touched.postOfficeBox && errors.postOfficeBox}
              helpTextType={errors.postOfficeBox && touched.postOfficeBox ? 'danger' : 'muted'}
              //@ts-ignore
              maxLength='20'
            />
          </Col>
          <Col md={6} className='mt-5 mt-md-5 mt-lg-5 mt-xl-5 mb-3 mb-md-4 mb-lg-4 mb-xl-4'>
            <Dropdown
              label={props.mpapd_country}
              options={countries?.map((item) => ({
                value: item.crmGuid || '',
                label: item.name || ''
              }))}
              //@ts-ignore
              name='countryCode'
              placeholder={props.mpapd_select}
              variant='search'
              helpText={touched.countryCode && errors.countryCode}
              helpTextType={touched.countryCode && errors.countryCode ? 'danger' : 'muted'}
              isSearchable
              // @ts-ignore
              onChange={(e) => {
                setFieldValue('countryCode', e)
              }}
              // @ts-ignore
              onBlur={(e) => {
                setFieldTouched(e)
              }}
              value={values.countryCode}
            />
          </Col>
          <Col md={6} className='mt-5 mt-md-5 mt-lg-5 mt-xl-5 mb-3 mb-md-4 mb-lg-4 mb-xl-4 d-none d-md-block' />
          <Col md={6} className='mt-5 mt-md-5 mt-lg-5 mt-xl-5 mb-3 mb-md-4 mb-lg-4 mb-xl-4'>
            <Text
              label={props.mpapd_telephone}
              type='text'
              value={values.telephone || ''}
              onChange={(e) => {
                setFieldValue('telephone', e.target.value)
              }}
              onBlur={() => setFieldTouched('telephone')}
              id='telephone'
              helpText={touched.telephone && errors.telephone}
              helpTextType={errors.telephone && touched.telephone ? 'danger' : 'muted'}
              //@ts-ignore
              maxLength='50'
              placeholder='+XX'
            />
          </Col>
          <Col md={6} className='mt-5 mt-md-5 mt-lg-5 mt-xl-5 mb-3 mb-md-4 mb-lg-4 mb-xl-4'>
            <Text
              label={props.mpapd_email}
              type='email'
              value={values.email || ''}
              onChange={(e) => {
                setFieldValue('email', e.target.value)
              }}
              onBlur={() => setFieldTouched('email')}
              id='email'
              disabled
              helpText={touched.mpapd_email && errors.mpapd_email}
              helpTextType={errors.mpapd_email && touched.mpapd_email ? 'danger' : 'muted'}
              //@ts-ignore
              maxLength='100'
            />
          </Col>
        </Row>

        {/* Subscribe to Press Releases */}
        <Row className='mt-4 mt-md-4 mt-lg-4 mt-xl-4 mb-9 mb-md-10 mb-lg-10 mb-xl-10 pt-0 g-5 g-md-6 g-xl-7'>
          <Col md={12} className='mt-0 pt-0'>
            <Checkbox
              align='right'
              checked={values.pressReleaseSubscribed}
              className='text-small d-flex'
              // @ts-ignore
              onChange={(e) => setFieldValue('pressReleaseSubscribed', e.target.checked)}
              //@ts-ignore
              onBlur={() => setFieldTouched('pressReleaseSubscribed')}
              label={props.mpapd_receive_pp}
              id='pressReleaseSubscribed'
              name='pressReleaseSubscribed'
            />
          </Col>
        </Row>

        {/* Cancel / Save changes */}
        <Row className='g-5 g-md-6 g-xl-7 mt-0 save-form'>
          <Col md={5} lg={4} xs={6} className='mt-0 pt-0'>
            <Button
              variant='secondary'
              onClick={() => {
                setProfileOpen(false)
                setTimeout(() => {
                  scrollToElement(
                    'press-accreditation-profile',
                    document.getElementsByClassName('profile-heading')[0]?.clientHeight
                  )
                }, 200)
              }}
            >
              {props.mpapd_cancel}
            </Button>
          </Col>
          <Col md={5} lg={4} xs={6} className='mt-0 pt-0'>
            <Button variant='primary' type='submit' isLoading={isSubmitting} disabled={isSubmitting}>
              {props.mpapd_save_changes}
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  </form>
)

const ProfileFormik = withFormik({
  mapPropsToValues: (props: any) => ({
    firstName: props.profile.firstName || '',
    lastName: props.profile.lastName || '',
    email: props.profile.email || '',
    companyName: props.profile.companyName || '',
    telephone: props.profile.telephone || '',
    street1: props.profile.street1 || '',
    street2: props.profile.street2 || '',
    street3: props.profile.street3 || '',
    city: props.profile.city || '',
    state: props.profile.state || '',
    zipCode: props.profile.zipCode || '',
    postOfficeBox: props.profile.postOfficeBox || '',
    pressReleaseSubscribed: props.profile.pressReleaseSubscribed,
    mailingSalutationId: props.profile.mailingSalutationId?.toString() || '',
    mediaType: props.profile.mediaType?.toString() || '',
    mediaFunction: props.profile.mediaFunction?.toString() || '',
    countryCode: props.profile.countryCode || ''
  }),
  validationSchema: ({ props }) =>
    Yup.object().shape({
      firstName: Yup.string()
        .matches(validationConstants.NON_ROMAN, props.valmsg_accept_only_roman_text)
        .required(props.valmsg_field_required || 'This field is required.'),
      lastName: Yup.string()
        .matches(validationConstants.NON_ROMAN, props.valmsg_accept_only_roman_text)
        .required(props.valmsg_field_required || 'This field is required.'),
      companyName: Yup.string().required(props.valmsg_field_required || 'This field is required.'),
      telephone: Yup.string()
        .matches(validationConstants.PHONE, 'Please use the following format: +41 43 123 45 67') // todo: MCHGB-270
        .required(props.valmsg_field_required || 'This field is required.'),
      postOfficeBox: Yup.string()
        .nullable()
        .test(
          'postOfficeBox depends on street1',
          props.valmsg_field_required || 'This field is required.',
          function validate(this: any, value) {
            return !(!value && !this.parent.street1)
          }
        ),
      street1: Yup.string()
        .nullable()
        .test(
          'street1 depends on postOfficeBox',
          props.valmsg_field_required || 'This field is required.',
          function validate(this: any, value) {
            return !(!value && !this.parent.postOfficeBox)
          }
        ),
      city: Yup.string()
        .nullable()
        .required(props.valmsg_field_required || 'This field is required.'),
      mailingSalutationId: Yup.string().required(props.valmsg_field_required || 'This field is required.'),
      mediaType: Yup.string().required(props.valmsg_field_required || 'This field is required.'),
      mediaFunction: Yup.string().required(props.valmsg_field_required || 'This field is required.'),
      countryCode: Yup.string().required(props.valmsg_field_required || 'This field is required.')
    }),
  handleSubmit: (values, { setSubmitting, props }) => {
    const valuesToSend = { ...values }
    delete valuesToSend.email
    valuesToSend.mediaType = parseInt(valuesToSend.mediaType)
    valuesToSend.mediaFunction = parseInt(valuesToSend.mediaFunction)

    const prepareValues = {
      properties: Object.entries(valuesToSend).map((i) => ({ name: i[0], value: i[1] }))
    }

    PressAccService.updateProfile(prepareValues).then(
      (response) => {
        if (response.ok) {
          props.props.getPressAccData()
          setTimeout(() => {
            scrollToElement(
              'press-accreditation-profile',
              document.getElementsByClassName('profile-heading')[0]?.clientHeight
            )
            props.setProfileOpen(false)
            setSubmitting(false)
          }, 200)
        }
      },
      () => {
        setSubmitting(false)
      }
    )
  },
  displayName: 'EditProfile' // helps with React DevTools
})(ProfileFormikComponent)

const ProfileForm: any = (props) => <ProfileFormik {...props} />

export default ProfileForm
